import { render, staticRenderFns } from "./AmountPicker.vue?vue&type=template&id=25159955&"
import script from "./AmountPicker.vue?vue&type=script&lang=js&"
export * from "./AmountPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports